import React, {
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { LoginContext } from "helpers/LoginContext";
import Header from "components/common/Header/Header";
import SideBar from "components/common/SideBar/SideBarNew";
import {
  ROSTERING_BREADCRUMB,
  ROSTERING_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import Breadcrumb from "components/common/Breadcrumb";
import CheckBox from "components/common/checkBox/checkbox";
import SelectionSummary from "./SelectionSummary";
import ExportedSelectedTimesheet from "./ExportSelectedTimesheet/ExportSelectedTimesheet";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  PAYROLL_EXPORT_STATUS,
  TIMESHEET_PROGRESS_STATUS,
  TIMESHEET_STATUS,
  TOAST_TYPE,
} from "Constants/constant";
import RosteringAPI from "store/services/rostering.services";
import SweetAlertConfirmationModal from "components/common/SweetAlertConfirmation/SweetAlertConfirmation";
import _ from "lodash";
import { showToast } from "store/actions/general.actions";
import { TOAST_IDS } from "store/constants";
import { timesheetStatusChangedLocally } from "store/actions/rostering.actions";
import PayrollTimesheetStatusPopover from "./PayrollTimesheetStatusPopover";
import {
  filterNonPayrollRecords,
  isExistPayrollPlatform,
  parseBooleanVal,
  hasCheckTimesheetStatus,
  checkWorkerAllTimesheetsSuccess,
  checkWorkerAnyTimesheetsFailedOrError,
  classNames,
  formatDateIntoDMY,
  addMonths,
  baseURLImage,
  getNameProfile,
  truncateTextReporting,
  formatHours,
} from "Utils/utils";
import usePayrollAuthentication from "hooks/usePayrollAuthentication";
import CustomButton from "components/common/Button/CustomButton";
import { TiExportOutline } from "react-icons/ti";
import ExportCSVModal from "./ExportSelectedTimesheet/ExportCSVModal";
import { getSpRosteringSetting } from "store/selector/sp.selector";
import moment from "moment";
import { spRosteringSettingsRequest } from "store/actions/sp.actions";
import TimesheetFilterField from "../UpdatedTimeSheet/components/TimesheetRevamp/TimesheetFilterField";
import TimesheetFilterDateRange from "../UpdatedTimeSheet/components/TimesheetRevamp/TimesheetFilterDateRange";
import "../UpdatedTimeSheet/components/TimesheetRevamp/timesheet-detail-revamp.css";

const ExportTimeSheet = (props) => {
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);

  const {
    workerTimeSheetExportListRequest,
    workerTimeSheetExportList,
    workerTimeSheetExportListLoader,
    exportTimesheetToPayrollRequest,
    exportTimesheetToPayrollLoader,
  } = props;

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);

    const [selectedFromDate, setSelectedFromDate] = useState(null);
  const { isAuthenticateForPayrolls } = usePayrollAuthentication();
const  spRosteringSetting = useSelector(getSpRosteringSetting)
  const dispatch = useDispatch();

  useEffect(()=>{
dispatch(spRosteringSettingsRequest())
  },[])

  const handleDateChange = (dates) => {
 
    if (dates && dates?.fromDate) {
      setStartDate(dates.fromDate);
    }
    if (dates && dates?.toDate) {
      setEndDate(dates.toDate);
    }
  };

  useEffect(() => {
    if (startDate && endDate && !workerTimeSheetExportListLoader) {
      workerTimeSheetExportListRequest({
        start_date: formatDateIntoDMY(startDate),
        end_date: formatDateIntoDMY(endDate),
      });
      setCheckboxes([]);
    }
  }, [startDate, endDate]);

  const [selectAll, setSelectAll] = useState(false);
  const [checkboxes, setCheckboxes] = useState([]);
  const [isShowCsvModal, setShowCSVModal] = useState(false);
  const prevWorkerListRef = React.useRef(null);
  const workspaceRef = useRef(null);
  const [workspaceHeight, setWorkspaceHeight] = useState(560);

  const syncWorkspaceHeight = useCallback(() => {
    if (typeof window === "undefined" || window.innerWidth < 1024) return;
    const el = workspaceRef.current;
    if (!el) return;
    const top = el.getBoundingClientRect().top;
    const available = window.innerHeight - top - 24;
    setWorkspaceHeight(Math.max(360, Math.floor(available)));
  }, []);

  useEffect(() => {
    window.addEventListener("resize", syncWorkspaceHeight);
    return () => window.removeEventListener("resize", syncWorkspaceHeight);
  }, [syncWorkspaceHeight]);

  const handleSelectAll = (val) => {
    if (val) {
      const filter = workerTimeSheetExportList
        .filter(filterNonPayrollRecords)
        .map((s) => {
          const existing = checkboxes.find((x) => x.uuid === s.uuid);
          if (existing) return { ...existing };
          // Select all non-success timesheets for this worker as children
          const children = (s.timeSheet || []).filter(
            (t) => !hasCheckTimesheetStatus(t, PAYROLL_EXPORT_STATUS.SUCCESS)
          );
          return { ...s, children };
        });
      setCheckboxes([...filter]);
    } else {
      setCheckboxes([]);
    }
  };

  const handleCheckboxChange = (e, uuid, item) => {
    const prevData = _.cloneDeep(checkboxes);
    if (e) {
      prevData.push({ ...item });
      setCheckboxes([...prevData]);
    } else {
      const filteredList = prevData.filter((c) => c.uuid !== uuid);
      setCheckboxes([...filteredList]);
    }
  };

  useEffect(() => {
    if (
      workerTimeSheetExportList &&
      checkboxes &&
      checkboxes.length ===
        workerTimeSheetExportList.filter(filterNonPayrollRecords).length &&
      workerTimeSheetExportList.length !== 0
    ) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [checkboxes, workerTimeSheetExportList]);

  const handleChildItemTimeSheet = (
    parentUUID,
    e,
    uuid,
    item,
    isAllSelect = null
  ) => {
    const index = checkboxes.findIndex((x) => x.uuid === parentUUID);

    if (isAllSelect !== null && index !== -1) {
      const prevSelectedWorkerCheckbox = _.cloneDeep(checkboxes);
      if (isAllSelect) {
        const parentWorker = workerTimeSheetExportList.find(
          (x) => x.uuid === parentUUID
        );
        if (parentWorker) {
          Object.assign(prevSelectedWorkerCheckbox[index], {
            children: [
              ...(parentWorker.timeSheet?.filter(
                (x) =>
                  !hasCheckTimesheetStatus(x, PAYROLL_EXPORT_STATUS.SUCCESS)
              ) || []),
            ],
          });
        }
      } else {
        prevSelectedWorkerCheckbox.splice(index, 1, {
          ...prevSelectedWorkerCheckbox[index],
          children: [],
        });
      }
      setCheckboxes([...prevSelectedWorkerCheckbox]);
      return;
    }
    if (index !== -1) {
      const data = _.cloneDeep(checkboxes);
      if (e === true) {
        data[index].children.push({ ...item });
      } else {
        const childIndex = data[index]?.children?.findIndex(
          (i) => i.uuid === uuid
        );
        if (childIndex !== -1) {
          data[index].children.splice(childIndex, 1);
        }
      }
      setCheckboxes([...data]);
    }
  };

  const getAllChilds = () => {
    return checkboxes
      .filter((y) => y.children.length > 0)
      .filter((x) => !hasCheckTimesheetStatus(x, PAYROLL_EXPORT_STATUS.SUCCESS))
      .map((x) => {
        return {
          p_id: x.id,
          p_uuid: x.uuid,
          children: [
            ...x.children.map((m) => m.uuid),
            // ...getWorkerSuccesstimesheet(x.uuid),
          ],
        };
      });
  };

  const handleChangeStatusPaid = async () => {
    let uuids = [];
    getAllChilds().forEach((item) => uuids.push(...item.children));
    const data = {
      uuid: uuids,
      status: TIMESHEET_STATUS.PAID,
    };

    try {
      setIsLoading(true);
      const response = await RosteringAPI.changeTimesheetStatus(data);
      if (response) {
        dispatch(
          timesheetStatusChangedLocally({
            employees: getAllChilds(),
            status: TIMESHEET_PROGRESS_STATUS.PAID.value,
          })
        );
        toast.success(
          `Timesheet${uuids.length === 1 ? "" : "s"} Paid Successfully!`
        );
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log("err", err);
      toast.error(err?.message ?? "Something went wrong!");
    }
  };

  const handlePayrollExportTimeSheet = async (payrollType) => {
    try {
      if (
        isAuthenticateForPayrolls !== null &&
        payrollType &&
        isExistPayrollPlatform(payrollType) &&
        parseBooleanVal(isAuthenticateForPayrolls[payrollType])
      ) {
        if (getAllChilds().length === 0) {
          dispatch(
            showToast({
              id: TOAST_IDS.EXPORT_SELECTED_TIMESHEET_ID,
              type: TOAST_TYPE.DEFAULT,
              title: "No any timesheet selected!",
            })
          );
          return;
        }
        const payload = getAllChilds().map((x) => ({
          uuid: x.p_uuid,
          // id: x.id,
          timesheets: [...x.children],
        }));
        exportTimesheetToPayrollRequest({
          type: payrollType,
          employees: payload,
          start_date: formatDateIntoDMY(startDate),
          end_date: formatDateIntoDMY(endDate),
        });
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    // only run when workerTimeSheetExportList reference actually changed
    if (prevWorkerListRef.current === workerTimeSheetExportList) return;
    prevWorkerListRef.current = workerTimeSheetExportList;

    if (workerTimeSheetExportList && workerTimeSheetExportList.length > 0) {
      const filter = checkboxes.map((s) => {
        const foundWorker = workerTimeSheetExportList.find(
          (x) => x.uuid === s.uuid
        );
        return foundWorker ? { ...foundWorker, children: s.children || [] } : s;
      });
      setCheckboxes([...filter]);
    }
  }, [workerTimeSheetExportList, checkboxes]);


  
    useEffect(() => {
      if (!spRosteringSetting) return;
  
      if (spRosteringSetting.calendar_type === "weekly") {
        const startOfWeek = moment().startOf("isoWeek");
        const endOfWeek = moment(startOfWeek).endOf("isoWeek");
        const from = startOfWeek.format("YYYY-MM-DD");
        const to = endOfWeek.format("YYYY-MM-DD");
        
        setStartDate(from);
        setEndDate(to);
      } else {
        // const startOfWeek = moment().startOf("isoWeek");
        // const endOfWeek = moment(startOfWeek).add(13, "days");
        // const currentMonday = startOfWeek.clone();
  
        const today = moment();
        if (spRosteringSetting.default_fortnight === "f1") {
          const referenceMonday = moment("2025-01-06");
  
          const daysSinceRef = today.diff(referenceMonday, "days");
          const fortnightsSinceRef = Math.floor(daysSinceRef / 14);
  
          const currentMonday = moment(referenceMonday).add(
            fortnightsSinceRef * 14,
            "days"
          );
  
          const from = currentMonday.format("YYYY-MM-DD");
          const to = moment(currentMonday).add(13, "days").format("YYYY-MM-DD");
     
          setStartDate(from);
          setEndDate(to);
        } else if (spRosteringSetting.default_fortnight === "f2") {
          const referenceMondayPrevious = moment("2025-01-13");
          const daysSinceRefPrevious = today.diff(
            referenceMondayPrevious,
            "days"
          );
          const fortnightsSinceRefPrevious = Math.floor(
            daysSinceRefPrevious / 14
          );
          const previousMonday = moment(referenceMondayPrevious).add(
            fortnightsSinceRefPrevious * 14,
            "days"
          );
          const previousFortnightEnd = moment(previousMonday).add(13, "days");
          // const previousMonday = currentMonday.clone().subtract(7, "days");
          // const endOfPreviousWeek = moment(previousMonday).add(13, "days");
          const from = previousMonday.format("YYYY-MM-DD");
          const to = previousFortnightEnd.format("YYYY-MM-DD");
  
         setStartDate(from);
          setEndDate(to);
        }
      }
    }, [spRosteringSetting]);

  const visibleWorkers = useMemo(
    () =>
      (workerTimeSheetExportList || []).filter(
        (worker) => worker?.timeSheet?.length > 0
      ),
    [workerTimeSheetExportList]
  );

  useLayoutEffect(() => {
    if (
      workerTimeSheetExportListLoader ||
      isAuthenticateForPayrolls === null
    ) {
      return;
    }
    syncWorkspaceHeight();
  }, [
    workerTimeSheetExportListLoader,
    isAuthenticateForPayrolls,
    visibleWorkers.length,
    syncWorkspaceHeight,
  ]);

  const sidebarTotals = useMemo(() => {
    let itemCount = 0;
    let sleepoverCount = 0;
    let totalMinutes = 0;
    visibleWorkers.forEach((worker) => {
      itemCount += worker.timeSheet?.length || 0;
      sleepoverCount += Number(worker.sleepover_count) || 0;
      const length = String(worker.ttl_timesheet_length || "");
      if (length.includes(":")) {
        const [h, m] = length.split(":").map((n) => parseInt(n, 10) || 0);
        totalMinutes += h * 60 + m;
      }
    });
    const hours = Math.floor(totalMinutes / 60);
    const minutes = Math.round(totalMinutes % 60);
    return {
      itemCount,
      sleepoverCount,
      hoursDisplay: formatHours(`${hours}:${minutes}`) || "00:00",
    };
  }, [visibleWorkers]);

  const selectableWorkerCount = workerTimeSheetExportList.filter(
    filterNonPayrollRecords
  ).length;
  const allWorkersSelected =
    checkboxes.length > 0 && selectableWorkerCount === checkboxes.length;

  const handleImageError = (e, fname, lname) => {
    e.target.src = getNameProfile(fname, lname);
  };

  return (
    <main className='min-h-full bg-[#F6F7F8]'>
      <SideBar />
      <div
        className={`duration-300 flex flex-col ${
          sideBarPadding ? "lg:pl-[4rem]" : "lg:pl-64"
        }`}
      >
        <Header
          cssClass='z-[10]'
          breadcrumb={
            <Breadcrumb
              pages={ROSTERING_BREADCRUMB(
                ROSTERING_BREADCRUMB_PAGES.EXPORTTIMESHEET
              )}
            />
          }
        />

        <section className='min-w-0 overflow-x-hidden px-3 pt-4 pb-6 sm:px-4'>
          <section className='timesheet-filter-bar rounded-2xl border border-[#E5E7EB] bg-white px-3 py-3 sm:px-3.5'>
            <div className='flex flex-col gap-3 md:flex-row md:items-end md:justify-between md:gap-3'>
              <TimesheetFilterField
                label='Date range'
                className='w-full min-w-0 md:w-auto'
              >
                <TimesheetFilterDateRange
                  fromDate={startDate}
                  toDate={endDate}
                  handleChange={handleDateChange}
                  setSelectedFromDate={setSelectedFromDate}
                  maxDate={addMonths(selectedFromDate, 1)}
                  isAllreadySelectedTimesheet
                  setCheckboxes={setCheckboxes}
                />
              </TimesheetFilterField>
              <CustomButton
                isDisabled={isUserGracePeriodOver}
                clickHandler={() => {
                  if (isUserGracePeriodOver) {
                    return;
                  }
                  setShowCSVModal(true);
                }}
                variant='tertiary'
                label={"Export To CSV"}
                cssClass={classNames(
                  "!rounded-[10px] flex items-center background-gradient border-gradient text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-[#4A6BB6]/30 focus:ring-offset-2",
                  !isUserGracePeriodOver && "cursor-pointer"
                )}
                loaderCssClass={"text-black"}
                Icon={<TiExportOutline className='h-5 w-5' />}
              />
            </div>
          </section>

          {workerTimeSheetExportListLoader ||
          isAuthenticateForPayrolls === null ? (
            <div className='mt-3 flex min-h-[420px] w-full items-center justify-center rounded-2xl border border-[#E5E7EB] bg-white'>
              <CircularLoader
                classes='flex justify-center items-center'
                classloader='loader-l'
              />
            </div>
          ) : (
            <div
              ref={workspaceRef}
              className='timesheet-workspace mt-3 flex flex-col gap-3 lg:flex-row lg:gap-4'
              style={{ "--timesheet-workspace-h": `${workspaceHeight}px` }}
            >
              <aside className='timesheet-workspace-sidebar relative flex h-[min(360px,50vh)] w-full shrink-0 flex-col overflow-hidden rounded-2xl border border-[#E5E7EB] bg-white lg:h-auto lg:w-[260px]'>
                <div className='flex items-center justify-between border-b border-[#E5E7EB] px-4 py-3.5'>
                  <div className='flex items-center gap-2'>
                    <span className='text-sm font-bold text-[#0F172A]'>
                      Workers
                    </span>
                    <span className='rounded-full bg-[#EEF2FB] px-2 py-0.5 text-[11px] font-bold text-[#4A6BB6]'>
                      {visibleWorkers.length}
                    </span>
                  </div>
                  {visibleWorkers.length > 0 && (
                    <button
                      type='button'
                      onClick={() => handleSelectAll(!selectAll)}
                      className='text-[11px] font-semibold text-[#4A6BB6] hover:underline'
                    >
                      {allWorkersSelected ? "Deselect all" : "Select all"}
                    </button>
                  )}
                </div>

                <div className='timesheet-panel-scroll flex-1 space-y-2 overflow-y-auto p-3 min-h-0'>
                  {visibleWorkers.map((item) => {
                    const isSelected = Boolean(
                      checkboxes.find((x) => x.uuid === item.uuid)
                    );
                    const initials = `${(item?.first_name || "").charAt(0)}${(
                      item?.last_name || ""
                    ).charAt(0)}`.toUpperCase();
                    const sleepoverCount = Number(item.sleepover_count) || 0;
                    let cardClasses =
                      "w-full flex cursor-pointer items-center gap-2.5 rounded-xl border px-3 py-2.5 transition-colors";
                    if (isSelected) {
                      cardClasses += " border-[#4A6BB6] bg-[#EEF2FB]";
                    } else {
                      cardClasses += " border-[#D4E9BE] bg-[#EDF7E1]";
                    }

                    return (
                      <div
                        key={item.uuid || item.id}
                        className={cardClasses}
                        onClick={() => {
                          if (!filterNonPayrollRecords(item)) return;
                          handleCheckboxChange(!isSelected, item.uuid, item);
                        }}
                        title={`${item.first_name} ${item.last_name}`}
                      >
                        <div
                          className='flex-shrink-0'
                          onClick={(e) => e.stopPropagation()}
                        >
                          <CheckBox
                            handleChange={(e) =>
                              handleCheckboxChange(e, item.uuid, item)
                            }
                            checked={isSelected}
                            cssClass='border-gray-500 rounded-sm'
                            isDisabled={!filterNonPayrollRecords(item)}
                          />
                        </div>
                        <div className='h-9 w-9 flex-shrink-0'>
                          {item?.photo ? (
                            <img
                              onError={(e) =>
                                handleImageError(
                                  e,
                                  item.first_name,
                                  item.last_name
                                )
                              }
                              className='h-9 w-9 rounded-full object-cover'
                              src={baseURLImage(item.photo)}
                              alt='avatar'
                            />
                          ) : (
                            <div className='flex h-9 w-9 items-center justify-center rounded-full bg-[#EEF2FB] text-xs font-bold text-[#4A6BB6]'>
                              {initials}
                            </div>
                          )}
                        </div>
                        <div className='flex min-w-0 flex-1 flex-col gap-0.5'>
                          <div className='flex min-w-0 items-center gap-1.5'>
                            <label className='mb-0 cursor-pointer whitespace-nowrap text-sm font-semibold capitalize text-[#0F172A]'>
                              {truncateTextReporting(
                                `${item.first_name} ${item.last_name}`,
                                14
                              )}
                            </label>
                            <span
                              className='flex-shrink-0'
                              onClick={(e) => e.stopPropagation()}
                            >
                              <PayrollTimesheetStatusPopover
                                isAllSuccess={
                                  checkWorkerAllTimesheetsSuccess(
                                    item?.timeSheet
                                  ).length === item?.timeSheet.length
                                }
                                isAnyFailed={
                                  checkWorkerAnyTimesheetsFailedOrError(
                                    item?.timeSheet
                                  ).length > 0
                                }
                                item={item}
                                isPayrollIdExists={filterNonPayrollRecords(
                                  item
                                )}
                                payrollType={item.payroll_platform}
                                isConsoleLog={
                                  `${item.first_name} ${item.last_name}` ===
                                  "Chastity Prince"
                                }
                              />
                            </span>
                          </div>
                          <span className='text-[11px] font-medium text-[#64748B]'>
                            {item.timeSheet.length} items
                            {item.ttl_timesheet_length &&
                            item.ttl_timesheet_length.includes(":")
                              ? ` · ${formatHours(item.ttl_timesheet_length)}`
                              : ""}
                          </span>
                          {sleepoverCount > 0 && (
                            <span className='text-[11px] font-medium text-[#64748B]'>
                              Sleepover: {sleepoverCount}
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  {visibleWorkers.length === 0 && (
                    <div className='flex h-32 items-center justify-center'>
                      <p className='mb-0 text-xs text-[#94A3B8]'>
                        No workers found
                      </p>
                    </div>
                  )}
                </div>

                {visibleWorkers.length > 0 && (
                  <div className='shrink-0 border-t border-[#E5E7EB] bg-gradient-to-r from-[#4A6BB6] to-[#3D5A9A] px-4 py-2.5 text-xs font-bold text-white'>
                    <div className='flex flex-wrap items-center gap-x-2 gap-y-0.5'>
                      <span>
                        {sidebarTotals.itemCount} Items
                        {sidebarTotals.sleepoverCount > 0
                          ? ` · ${sidebarTotals.sleepoverCount} Sleepover${
                              sidebarTotals.sleepoverCount === 1 ? "" : "s"
                            }`
                          : ""}
                      </span>
                      <span aria-hidden>·</span>
                      <span>{sidebarTotals.hoursDisplay} Hours</span>
                    </div>
                  </div>
                )}
              </aside>

              <section className='timesheet-workspace-table relative flex h-[min(440px,52vh)] min-h-[280px] w-full min-w-0 flex-col overflow-hidden rounded-2xl border border-[#E5E7EB] bg-white lg:h-auto lg:min-h-0 lg:flex-1'>
                <div className='shrink-0 border-b border-[#E5E7EB] px-3 py-3 sm:px-4'>
                  <SelectionSummary
                    selectedWorkers={checkboxes}
                    selectedChilds={checkboxes.filter(
                      (x) => x?.children && x.children.length > 0
                    )}
                  />
                </div>
                <div className='timesheet-panel-scroll min-h-0 flex-1 overflow-y-auto px-3 py-3 sm:px-4'>
                  <ExportedSelectedTimesheet
                    isAuthenticateForPayrolls={isAuthenticateForPayrolls}
                    handlePayrollExportTimeSheet={handlePayrollExportTimeSheet}
                    paidStatusChangeStatusLoader={isLoading}
                    handleChangeStatusPaid={() => {
                      if (getAllChilds().length === 0) {
                        dispatch(
                          showToast({
                            id: TOAST_IDS.MARK_SELECTED_TIMESHEET_PAID_ID,
                            type: TOAST_TYPE.DEFAULT,
                            title: "No any timesheet selected!",
                          })
                        );
                        return;
                      }
                      setIsConfirm(true);
                    }}
                    handleChildItemTimeSheet={handleChildItemTimeSheet}
                    selectedWorkers={checkboxes}
                    exportTimesheetToPayrollLoader={
                      exportTimesheetToPayrollLoader
                    }
                  />
                </div>
              </section>
            </div>
          )}
        </section>
      </div>

      {isShowCsvModal && (
        <ExportCSVModal
          handleClose={() => setShowCSVModal(false)}
          isShow={isShowCsvModal}
          workerTimeSheetExportListRequest={workerTimeSheetExportListRequest}
          workerTimeSheetExportList={workerTimeSheetExportList}
        />
      )}
      {isConfirm && (
        <SweetAlertConfirmationModal
          isOpen={isConfirm}
          title='Timesheet paid'
          content={`Are you sure you want to paid timesheet${
            getAllChilds().length > 1 ? "s" : ""
          }?`}
          dangerMode={true}
          setIsConfirm={(value) => {
            if (value === true) {
              setIsConfirm(false);
              handleChangeStatusPaid();
            } else {
              setIsConfirm(false);
            }
          }}
        />
      )}
    </main>
  );
};

export default ExportTimeSheet;
